import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { TournamentsService } from '../tournaments/services/tournaments.service';
declare let $;

@Component({
    selector: 'app-qr-reward',
    templateUrl: './qr-reward.component.html',
    styleUrls: ['./qr-reward.component.scss'],
})
export class QrComponent implements OnInit {
    qrCode = '';
    qrInterval;

    qrCodeSubscription: Subscription;

    constructor(
        private _uiHelper: uiHelper,
        public translate: translationHelper,
        public tournamentsService: TournamentsService,
    ) {
        this.qrCodeSubscription = this._uiHelper.qrCodeListener.subscribe(x => {
            if (x != 0) {
                this.qrCode = x;
                let thiss = this;

                // 5 saniyede bir kullanıcı giriş yaptı mı diye sorgu at
                this.qrInterval = setInterval(function() {
                    thiss.procBranchQrControlResult();
                }, 5000);

                // 300 saniye sonra temizle
                setTimeout(function() {
                    thiss.modalHide();
                }, 300000);
            }
        });
    }

    ngOnInit() {}

    modalHide() {
        clearInterval(this.qrInterval);
        $('#Qr_Reward_Modal').modal('hide');
    }

    public procBranchQrControlResult() {
        // this.tournamentsService.procBranchQrControlResult().then((result: any) => {
        //     if (result.ResultCode > 0) {
        //         // KART takma işlemleri result.Code
        //         const CustomerIdString = result.Code.toString();
        //         this._uiHelper.SetCustomerQrStatus(true);
        //         // console.log('#--QR--#', CustomerIdString);
        //         // this.coreService.CustomerCardBalance(CustomerIdString);
        //         window.postMessage({ command: 'cardinserted', message: CustomerIdString }, '*');
        //         this.modalHide();
        //     }
        // });
    }
}
